import { createContext } from "react";
import useAppointmentReminders from "../hooks/useAppointmentReminders.js";

/**
 * Shares a single reminder poller (and its notification permission state) with
 * the whole authenticated shell — the top-bar bell, the appointments settings
 * panel and the polling loop all read from one instance, so permission changes
 * propagate everywhere without spawning duplicate intervals.
 */
const ReminderContext = createContext(null);

export function ReminderProvider({ children, enabled = true }) {
  const value = useAppointmentReminders({ enabled });
  return (
    <ReminderContext.Provider value={value}>
      {children}
    </ReminderContext.Provider>
  );
}

export default ReminderContext;
